const countryLocaleMap = {
  sv: 'SE',
  da: 'DK',
  de: 'DE',
};

export const getDefaultCountry = (locale: string) => {
  const country = countryLocaleMap[locale as keyof typeof countryLocaleMap];

  return country ?? 'DK';
};
